<template>
    <div class="container d-flex flex-column">
        <ValidationObserver ref="observer"
                            tag="form"
                            class="row d-flex justify-content-center mx-2 mt-5"
                            @submit.prevent="submit">
            <div class="col-xl-5 col-lg-7 col-md-9 bg-white shadow py-5 px-3 px-sm-5 rounded">
                <h4 class="mb-4 text-secondary">Paroles atjaunošana</h4>
                
                <div v-if="successMessage" class="alert alert-success mb-4">
                    {{ successMessage }}
                </div>
                
                <template v-else>
                    <p class="text-left mb-4 small text-secondary">
                        Ievadiet e-pasta adresi, un mēs Jums nosūtīsim instrukciju paroles atjaunošanai.
                    </p>

                    <ValidationProvider tag="div"
                                        class="mb-4"
                                        vid="email"
                                        mode="lazy"
                                        :customMessages="{required: 'Norādiet e-pastu.', email: 'Norādiet pareizu e-pastu.'}"
                                        rules="required|email"
                                        v-slot="{errors}">
                        <label for="email" class="d-block text-secondary text-left mb-0">E-pasts</label>
                        <input type="text" id="email" class="w-100 py-1 ds-input" v-model="email">
                        <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <CustomButton class="w-100" btn-text="Nosūtīt saiti" :is-loading="isLoading"/>
                </template>

                <div class="mt-4 text-center">
                    <router-link :to="{ name: 'login' }" class="text-secondary small">Atgiezties uz pieslēgšanos</router-link>
                </div>
                <div v-if="isRateLimited" class="text-danger d-block mt-2">Pārāk daudz mēģinājumu, lūdzu, mēģiniet vēlreiz vēlāk.</div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
    import { required, email } from 'vee-validate/dist/rules';
    import axios from 'axios';

    import CustomButton from '@/components/global/CustomButton';

    export default {
        name: 'ForgotPassword',
        components: {
            CustomButton,
            ValidationProvider,
            ValidationObserver,
        },
        created() {
            extend('required', required);
            extend('email', email);
        },
        data: () => ({
            email: '',
            isLoading: false,
            successMessage: '',
            isRateLimited: false,
        }),
        methods: {
            async submit() {
                this.isRateLimited = false;
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                this.isLoading = true;
                try {
                    const {data} = await axios.post('/api/auth/forgot-password', {
                        email: this.email
                    });
                    
                    if (data.success) {
                        this.successMessage = data.message;
                    }
                } catch (error) {
                    const errorData = error.response && error.response.data && error.response.data.error
                        ? error.response.data.error 
                        : null;

                    if (errorData && errorData.field) {
                        this.$refs.observer.setErrors({[errorData.field]: [errorData.message]});
                    } else if (errorData && errorData.isRateLimit) {
                        this.isRateLimited = true;
                    }
                } finally {
                    this.isLoading = false;
                }
            },
        },
    }
</script>
